import { useState, useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const TermsPage = () => {
  const [sections, setSections] = useState([]);

  useEffect(() => {
    axios.get(`${API}/terms`).then(res => setSections(res.data)).catch(() => {});
  }, []);

  return (
    <div className="min-h-screen" data-testid="terms-page">
      <Header />
      
      <main>
        <section className="py-12 md:py-16 bg-gradient-to-b from-[#fff5f5] to-[#FFFBF5]">
          <div className="container-gymtots text-center">
            <h1 
              className="text-3xl md:text-4xl font-bold text-[#2D3436] mb-4"
              style={{ fontFamily: 'Fredoka, cursive' }}
            >
              Terms & <span className="text-[#ff3131]">Conditions</span>
            </h1>
            <p className="text-[#636E72] max-w-xl mx-auto">
              Please read our terms and conditions carefully before booking.
            </p>
          </div>
        </section>

        <section className="py-12 md:py-16 bg-white">
          <div className="container-gymtots">
            <div className="max-w-3xl mx-auto">
              {sections.map((section, i) => (
                <div key={i} className="bg-[#FFFBF5] rounded-2xl p-6 mb-6" data-testid={`terms-section-${i}`}>
                  <h2 className="text-xl font-bold text-[#2D3436] mb-4" style={{ fontFamily: 'Fredoka, cursive' }}>
                    {section.title}
                  </h2>
                  <ul className="space-y-2 text-[#636E72] text-sm">
                    {(section.items || []).map((item, j) => (
                      <li key={j} className="flex items-start gap-2">
                        <span className="text-[#ff3131] mt-0.5">&#8226;</span>
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>
              ))}

              <div className="mt-8 text-center text-sm text-[#636E72]">
                <p>Questions? Contact us at <a href="mailto:admin@gym-tots.co.uk" className="text-[#ff3131] hover:underline">admin@gym-tots.co.uk</a></p>
              </div>
            </div>
          </div>
        </section>
      </main>
      
      <Footer />
    </div>
  );
};

export default TermsPage;
